import { AssessmentOverviewQuestionnaireItem } from '../sections/assessment-overview/questionnaire'
import { PatientOverviewQuestionnaireItem } from '../sections/patient-overview/questionnaire'
import { SupervisoryReviewQuestionnaireItem } from '../sections/supervisory-review/questionnaire'
import { FinalStepsQuestionnaireItem } from '../sections/final-steps/questionnaire'

// Amalgamate all section questionnaire enums
export const SupervisoryAssessmentQuestionnaireItem = {
  ...AssessmentOverviewQuestionnaireItem,
  ...PatientOverviewQuestionnaireItem,
  ...SupervisoryReviewQuestionnaireItem,
  ...FinalStepsQuestionnaireItem
} as const

export type SupervisoryAssessmentQuestionnaireItem =
  (typeof SupervisoryAssessmentQuestionnaireItem)[keyof typeof SupervisoryAssessmentQuestionnaireItem]
